import BathIcon from '@/../img/bath.svg';
import BedIcon from '@/../img/bed.svg';
import InfoIcon from '@/../img/info-icon.svg';
import { datasetSubtypeLabelsProper } from '@/constants';
import useRentalscapeConfig from '@/hooks/use-rentalscape-config';
import isUndefined from 'lodash/isUndefined';
import { useMemo } from 'react';
import { Tooltip, Whisper } from 'rsuite';
import styled from 'styled-components';
import { DetailsInfoDisplay } from './details-info-display';
import { Attribute, Value } from './details-info-mod-styles';

const PROPERTY_DETAILS = 'Property Details';
const APN = 'APN';
const ROOM = 'Room';
const FIRST_IDENTIFIED_DATE = 'First identified date';
const OWNER = 'Owner';
const OWNER_OCCUPIED = 'Owner occupied';
const OWNER_ADDRESS = 'Owner address';

function FirstIdentifiedDateIcon() {
  const tooltip =
    'This is the date on which the first listing was identified as belonging to this property address.';

  return (
    <Whisper
      placement="top"
      speaker={<Tooltip>{tooltip}</Tooltip>}
      trigger={['hover', 'focus']}
    >
      <button
        aria-label={tooltip}
        className="flex w-[15px] [&>svg]:w-[15px] after:!top-unset"
        type="button"
      >
        <InfoIcon aria-hidden />
      </button>
    </Whisper>
  );
}

const StyledDiv = styled.div`
  page-break-inside: avoid;
`;

const FlexRowAlign = styled.div`
  display: flex;
  flex-direction: row;
  align-content: center;
  justify-content: space-between;
`;

const IconSizer = styled.div`
  width: 16px;
  height: 16px;
  margin-left: 2px;
`;

function BedBathIconWithCount(props) {
  const { count: rawCount, Icon, iconLabel } = props;
  const count = rawCount || 'N/A';

  return (
    <div css="display: flex; align-items: center; margin-left: 10px;">
      <span>{count}</span>
      <IconSizer>
        <Icon aria-label={iconLabel} />
      </IconSizer>
    </div>
  );
}

function BedBathDisplay({ bedroom, bathroom }) {
  return (
    <FlexRowAlign>
      <BedBathIconWithCount count={bedroom} Icon={BedIcon} iconLabel="Bed(s)" />
      <BedBathIconWithCount
        count={bathroom}
        Icon={BathIcon}
        iconLabel="Bath(s)"
      />
    </FlexRowAlign>
  );
}

export function PropertyInfoMod(props) {
  const rentalscapeConfig = useRentalscapeConfig();
  const bedBathComponent = (
    <BedBathDisplay bedroom={props.bedroom} bathroom={props.bathroom} />
  );

  const ownerOccupiedLabel =
    datasetSubtypeLabelsProper.ownerOccupied[props.ownerOccupied];

  const firstIdentifiedDate = useMemo(() => {
    if (isUndefined(props.latestVerifiedDate)) return [];

    return [
      FIRST_IDENTIFIED_DATE,
      props.latestVerifiedDate,
      <FirstIdentifiedDateIcon key="info-icon" />,
    ];
  }, [props.latestVerifiedDate]);

  const rightDetails = [[OWNER, props.owner]];

  if (rentalscapeConfig?.showOwnerOccupied) {
    rightDetails.push([OWNER_OCCUPIED, ownerOccupiedLabel]);
  }

  return (
    <StyledDiv>
      <DetailsInfoDisplay
        title={PROPERTY_DETAILS}
        left={[[APN, props.apn], [ROOM, bedBathComponent], firstIdentifiedDate]}
        right={rightDetails}
      />
      {/* this is a hack for a demo.. Bing should give us a proper desgin */}
      <div css="display: flex; margin-top: -7px">
        <Attribute>{OWNER_ADDRESS}:</Attribute>
        <Value css="margin-left: 15px;">{props.ownerAddress}</Value>
      </div>
    </StyledDiv>
  );
}
